import { useTranslation } from 'react-i18next';

import Button from 'components/field/Button';
import LottiePlayer from 'components/global/LottiePlayer';
import Typography from 'components/global/Typography';
import { ModalActions, ModalContent } from 'components/global/styled/Modal.styled';

import * as S from './ChangePaymentMethodModal.styled';

export default function ChangePaymentMethodCompletedModal({
	closeModal,
	prevStep,
	cardLastFour,
	changeCardStatus,
	cancelDowngradeRequest
}) {
	const { t } = useTranslation();

	const changePaymentMethodAnimation = {
		failed: 'alert-error',
		changed: 'alert-success',
		success: 'alert-success'
	};

	const animationName = changePaymentMethodAnimation[changeCardStatus] ?? 'alert-success';

	return (
		<>
			<ModalContent>
				<S.CompletedContainer>
					<LottiePlayer name={animationName} width="300px" height="300px" />

					{changeCardStatus === 'failed' && (
						<Typography variant="p1" fontWeight="500" noWrap>
							{cancelDowngradeRequest
								? t('cancelDowngradeRequestFailedText')
								: t('changePaymentMethodFailedText')}
						</Typography>
					)}

					{changeCardStatus === 'changed' && (
						<Typography variant="p1" fontWeight="500" noWrap>
							{t('changePaymentMethodSuccessText', {
								cardLastFour
							})}
						</Typography>
					)}

					{changeCardStatus === 'success' && (
						<Typography variant="p1" fontWeight="500" noWrap>
							{t('youTurnAgainSubscriptionSuccessText', {
								cardLastFour
							})}
						</Typography>
					)}
				</S.CompletedContainer>
			</ModalContent>

			<ModalActions>
				{changeCardStatus === 'failed' && (
					<Button
						variant="outline"
						label={'returnToChangePaymentMethod'}
						onClick={() => {
							prevStep();
						}}
					/>
				)}

				<Button
					variant="blue"
					label="done"
					onClick={() => {
						closeModal();
					}}
				/>
			</ModalActions>
		</>
	);
}
